import { render } from "./jurnal.svg?vue&type=template&id=112bf642"
const script = {}
script.render = render

export default script